import IParser from "@/types/IParser"
import ParseError from "@/types/ParseError"
import dayjs from "dayjs"
import { JuniferTicket } from "./juniferTicket"
import { IJuniferTicket } from "./juniferTicket.types"
import { AccountTicket } from "@/api/backofficeRest/generated/model"

export interface ITicketEntities {
  accounts?: Array<string>
  meterPoints?: Array<string>
  paymentSchedulePeriods?: Array<string>
  customers?: Array<string>
  tickets?: Array<string>
  communications?: Array<string>
  bills?: Array<string>
  paymentRequests?: Array<string>
  paymentSchedulePeriod?: Array<string>
  paymentMethods?: Array<string>
  alerts?: Array<string>
  billPeriods?: Array<string>
  billingEntities?: Array<string>
  billEmails?: Array<string>
  changeOfTenancys?: Array<string>
  assets?: Array<string>
  contacts?: Array<string>
}

export type JunTicketStatusText = "Open" | "Closed" | "Cancelled" | "Error"
export type TicketPriority = "Medium" | "High" | "Major"

export type IJuniferTicketRaw = AccountTicket

export const JuniferTicketParser: IParser<IJuniferTicket, IJuniferTicketRaw> = {
  toDomain: (data: IJuniferTicketRaw) => {
    try {
      return new JuniferTicket(
        data.id,
        data.keyIdentifier,
        dayjs(data.createdDate),
        // The REST DTO declares this a plain string; the value set is closed
        // in practice, and the compiler has no way to narrow it further.
        data.status as JunTicketStatusText,
        data.ticketDefinitionCode,
        data.ticketDefinitionName,
        data.ticketPriority as TicketPriority,
        data.ticketStepCode,
        data.keyIdentifier,
        data.summary,
        data.description ?? "",
        data.assignedTeam ?? "",
        { accounts: data.ticketEntities.accounts ?? undefined },
      )
    } catch (error) {
      throw new ParseError(error)
    }
  },
}
